import {SURVEY_DETAIL_REQUESTED, SURVEY_DETAIL_UNLOAD, SURVEY_DETAIL_SUCCESS, SURVEY_DETAIL_FAILURE} from '../constants';

export const requestDetailSurvey = (id) => ({type: SURVEY_DETAIL_REQUESTED, payload: {id}});
export const surveyDetailSuccess = (data) => ({type: SURVEY_DETAIL_SUCCESS, payload: {data}});
export const surveyDetailFailure = (error) => ({type: SURVEY_DETAIL_FAILURE, payload: {error}});
export const unloadDetailSurvey = () => ({type: SURVEY_DETAIL_UNLOAD});
